export default "__VITE_ASSET__XlmWnrdn__"